/* NS POPUP NO PAGE JUMP v6 - no body repositioning, no scroll reset. */
(() => {
  'use strict';
  if (window.nsBuyQuantityInstalled || !window.HTMLDialogElement) return;
  window.nsBuyQuantityInstalled = true;
  const es = document.documentElement.lang.toLowerCase().startsWith('es');
  const copy = es ? {
    title: 'Cantidad', quantity: 'Cantidad', minus: 'Reducir cantidad',
    plus: 'Aumentar cantidad', checkout: 'Ir al pago', close: 'Cerrar', busy: 'Abriendo el pago…'
  } : {
    title: 'Quantity', quantity: 'Quantity', minus: 'Decrease quantity',
    plus: 'Increase quantity', checkout: 'Checkout', close: 'Close', busy: 'Opening checkout…'
  };
  let dialog, input, minus, plus, checkout, product, image, source, trigger;
  let pointerMode = false, pointerTrigger;
  function markPointerTrigger(button) {
    if (pointerTrigger !== button) pointerTrigger?.removeAttribute('data-ns-pointer-focus');
    pointerTrigger = button;
    pointerTrigger?.setAttribute('data-ns-pointer-focus', '');
  }
  document.addEventListener('pointerdown', event => {
    pointerMode = true;
    window.nsPopupInputMode = 'pointer';
    dialog?.classList.add('ns-buy-quantity--pointer');
    const button = event.target.closest?.('.ns-card-actions__buy-form button');
    if (button) markPointerTrigger(button);
  }, { capture: true, passive: true });
  document.addEventListener('keydown', event => {
    if (event.key === 'Shift' || event.key === 'Control' || event.key === 'Alt' || event.key === 'Meta') return;
    pointerMode = false;
    window.nsPopupInputMode = 'keyboard';
    dialog?.classList.remove('ns-buy-quantity--pointer');
    pointerTrigger?.removeAttribute('data-ns-pointer-focus');
    pointerTrigger = null;
  }, true);
  function create() {
    dialog = document.createElement('dialog');
    dialog.className = 'ns-buy-quantity';
    dialog.setAttribute('aria-labelledby', 'ns-buy-quantity-title');
    dialog.innerHTML = '<button type="button" class="ns-buy-quantity__close">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false"><path d="M6 6 18 18M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/></svg></button>' +
      '<h2 id="ns-buy-quantity-title"></h2><img class="ns-buy-quantity__image" width="88" height="88" alt="" hidden><p class="ns-buy-quantity__product"></p>' +
      '<form class="ns-buy-quantity__form"><label for="ns-buy-quantity-input"></label>' +
      '<div class="ns-buy-quantity__stepper"><button type="button" data-step="-1">−</button>' +
      '<input id="ns-buy-quantity-input" name="quantity" type="number" min="1" max="9007199254740991" step="1" value="1" inputmode="numeric" required>' +
      '<button type="button" data-step="1">+</button></div>' +
      '<button type="submit" class="ns-buy-quantity__checkout"></button></form>';
    const panel = document.createElement('div');
    panel.className = 'ns-popup-panel';
    while (dialog.firstChild) panel.append(dialog.firstChild);
    dialog.append(panel);
    document.body.append(dialog);
    dialog.querySelector('h2').textContent = copy.title;
    dialog.querySelector('label').textContent = copy.quantity;
    product = dialog.querySelector('.ns-buy-quantity__product');
    image = dialog.querySelector('.ns-buy-quantity__image');
    image.addEventListener('error', () => { image.hidden = true; });
    input = dialog.querySelector('input');
    minus = dialog.querySelector('[data-step="-1"]');
    plus = dialog.querySelector('[data-step="1"]');
    minus.setAttribute('aria-label', copy.minus);
    plus.setAttribute('aria-label', copy.plus);
    checkout = dialog.querySelector('[type="submit"]');
    checkout.textContent = copy.checkout;
    const close = dialog.querySelector('.ns-buy-quantity__close');
    close.setAttribute('aria-label', copy.close);
    close.addEventListener('click', () => dialog.close());
    for (const button of [minus, plus]) button.addEventListener('click', () => {
      if (!Number.isSafeInteger(input.valueAsNumber) || input.valueAsNumber < 1) input.value = '1';
      if (button === plus) input.stepUp();
      else if (input.valueAsNumber > 1) input.stepDown();
      sync();
    });
    input.addEventListener('input', sync);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      if (getComputedStyle(panel).display === 'block') { dialog.close(); return; }
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (trigger?.isConnected) {
        if (pointerMode) markPointerTrigger(trigger);
        trigger.focus({ preventScroll: true });
      }
      nsEnsurePopupViewport().release(dialog);
      source = null;
    });
    dialog.querySelector('form').addEventListener('submit', event => {
      event.preventDefault();
      if (checkout.disabled || !source?.isConnected) return;
      if (!Number.isSafeInteger(input.valueAsNumber) || input.valueAsNumber < 1) {
        input.reportValidity();
        return;
      }
      const quantity = source.querySelector('input[name="quantity"]');
      if (!quantity || !source.reportValidity()) return;
      quantity.value = String(input.valueAsNumber);
      checkout.disabled = true;
      checkout.textContent = copy.busy;
      dialog.setAttribute('aria-busy', 'true');
      // Preserve Shopify's native /cart/add + return_to checkout and existing cart.
      HTMLFormElement.prototype.submit.call(source);
    });
  }
  function sync() {
    minus.disabled = !(input.valueAsNumber > 1);
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.ns-card-actions__buy-form')) return;
    if (!form.querySelector('input[name="quantity"]') || !form.querySelector('input[name="id"]')) return;
    if (!dialog) create();
    if (typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (dialog.open) return;
    source = form;
    trigger = event.submitter || document.activeElement;
    dialog.classList.toggle('ns-buy-quantity--pointer', pointerMode);
    product.textContent = form.closest('.card-wrapper')?.querySelector('.card__heading')?.textContent.trim() || '';
    const cardImage = form.closest('.card-wrapper')?.querySelector('.card__media img, .card__inner .media img, .card__inner img');
    image.hidden = true;
    image.removeAttribute('src');
    if (cardImage) {
      const src = cardImage.currentSrc || cardImage.getAttribute('src');
      if (src) { image.src = src; image.hidden = false; }
    }
    input.value = '1';
    checkout.disabled = false;
    checkout.textContent = copy.checkout;
    dialog.removeAttribute('aria-busy');
    sync();
    nsEnsurePopupViewport().lock(dialog);
    try { dialog.showModal(); }
    catch (error) { nsEnsurePopupViewport().release(dialog); throw error; }
    // Avoid opening the phone keyboard on every purchase.
    plus.focus({ preventScroll: true });
  }, true);
  window.addEventListener('pageshow', () => {
    if (dialog?.open) dialog.close();
    if (checkout) { checkout.disabled = false; checkout.textContent = copy.checkout; }
  });
})();

/* Shared input lock: no page repositioning, overflow toggles or scroll reset. */
function nsEnsurePopupViewport() {
  if (window.nsPopupViewport) return window.nsPopupViewport;
  const active = new Set();
  let touch;
  function update() {
    const vv = window.visualViewport;
    for (const d of active) {
      d.style.setProperty('--ns-popup-vv-height', (vv?.height || window.innerHeight) + 'px');
      d.style.setProperty('--ns-popup-vv-width', (vv?.width || window.innerWidth) + 'px');
      d.style.setProperty('--ns-popup-vv-top', (vv?.offsetTop || 0) + 'px');
      d.style.setProperty('--ns-popup-vv-left', (vv?.offsetLeft || 0) + 'px');
    }
  }
  function canScroll(target, dx, dy) {
    const d = Array.from(active).at(-1);
    if (!d || !d.contains(target)) return false;
    for (let n = target instanceof Element ? target : target.parentElement; n && d.contains(n); n = n.parentElement) {
      const s = getComputedStyle(n);
      if (dy && /auto|scroll/.test(s.overflowY) && n.scrollHeight > n.clientHeight + 1 &&
          ((dy < 0 && n.scrollTop > 0) || (dy > 0 && n.scrollTop < n.scrollHeight - n.clientHeight - 1))) return true;
      if (dx && /auto|scroll/.test(s.overflowX) && n.scrollWidth > n.clientWidth + 1 &&
          ((dx < 0 && n.scrollLeft > 0) || (dx > 0 && n.scrollLeft < n.scrollWidth - n.clientWidth - 1))) return true;
    }
    return false;
  }
  function wheel(e) {
    if (!e.ctrlKey && !canScroll(e.target, e.deltaX, e.deltaY) && e.cancelable) e.preventDefault();
  }
  function start(e) {
    touch = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
  }
  function move(e) {
    if (!touch || e.touches.length !== 1) return;
    const p = e.touches[0], dx = touch.x - p.clientX, dy = touch.y - p.clientY;
    touch = { x: p.clientX, y: p.clientY };
    if (!canScroll(e.target, dx, dy) && e.cancelable) e.preventDefault();
  }
  function key(e) {
    const t = e.target;
    if (t instanceof Element && t.closest('input,textarea,select,[contenteditable="true"]')) return;
    if (e.key === ' ' && t instanceof Element && t.closest('button,a,summary')) return;
    if (['ArrowUp','ArrowDown','PageUp','PageDown','Home','End',' '].includes(e.key) &&
        !canScroll(t, 0, ['ArrowUp','PageUp','Home'].includes(e.key) || (e.key === ' ' && e.shiftKey) ? -1 : 1)) e.preventDefault();
  }
  window.nsPopupViewport = {
    lock(d) {
      if (active.has(d)) return;
      if (!active.size) {
        document.addEventListener('wheel', wheel, { capture: true, passive: false });
        document.addEventListener('touchstart', start, { capture: true, passive: true });
        document.addEventListener('touchmove', move, { capture: true, passive: false });
        document.addEventListener('keydown', key, true);
        window.addEventListener('resize', update);
        window.visualViewport?.addEventListener('resize', update);
        window.visualViewport?.addEventListener('scroll', update);
      }
      active.add(d);
      update();
    },
    release(d) {
      if (!active.delete(d)) return;
      for (const p of ['height','width','top','left']) d.style.removeProperty('--ns-popup-vv-' + p);
      if (active.size) return;
      document.removeEventListener('wheel', wheel, true);
      document.removeEventListener('touchstart', start, true);
      document.removeEventListener('touchmove', move, true);
      document.removeEventListener('keydown', key, true);
      window.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('resize', update);
      window.visualViewport?.removeEventListener('scroll', update);
      touch = null;
    }
  };
  return window.nsPopupViewport;
}
